import React, { useState } from "react";
import { TextField, Autocomplete, IconButton, Typography, createFilterOptions } from "@mui/material";
import DynamicHtml from "@common/DynamicHtml";
import { ClearIcon } from "@mui/x-date-pickers";
import { Search } from "@mui/icons-material";
import Helper from "../../Helper";

const PlanSearchSection = ({ 
  isPlanSearchRequired, 
  showPostSearch, 
  safeChannelName, 
  resultNameLabel, 
  plans, 
  resultHierarchyName, 
  selectedResult, 
  handleResultSearch, 
  highlightPlanSearch, 
  setHighlightPlanSearch, 
  isPlanSearchEnabled, 
  noResultsMessage, 
  handlePlanClear,
  noResultsType,
  searchPageState,
}) => {
  if (!isPlanSearchRequired || showPostSearch) return null;
  const [inputResultName, setInputResultName] = useState("");

  const filterOptions = createFilterOptions({
    trim: true,
  });

  return (
    <div className={`norstella-pf-row norstella-pf-row-plan norstella-pf-${safeChannelName}-row-plan norstella-pf-${searchPageState}-row-plan`}>
      <div className={`norstella-pf-plan-search-row norstella-pf-${safeChannelName}-plan-search-row norstella-pf-${searchPageState}-plan-search-row`}>
        <label className={`norstella-pf-plan-label norstella-pf-${safeChannelName}-plan-label norstella-pf-${searchPageState}-plan-label`}>{resultNameLabel}</label>
        <div
          className={`norstella-pf-input-group norstella-pf-plan-input-group norstella-pf-input-with-icon norstella-pf-${safeChannelName}-plan-input-with-icon norstella-pf-${searchPageState}-plan-input-with-icon ${!isPlanSearchEnabled ? "norstella-pf-disabled" : ""} ${highlightPlanSearch ? "norstella-pf-highlight-search" : ""}`}
        >
          <Autocomplete
            id="resultSelect"
            className={`norstella-pf-plan-search-input norstella-pf-${safeChannelName}-plan-search-input norstella-pf-${searchPageState}-plan-search-input`}
            part="cfSearchText"
            blurOnSelect
            handleHomeEndKeys
            disablePortal
            filterOptions={filterOptions}
            disabled={!isPlanSearchEnabled}
            options={plans}
            getOptionLabel={(option) => Helper.retrieveResultName(option, resultHierarchyName)}
            value={selectedResult}
            inputValue={inputResultName}
            onChange={(_, newValue) => handleResultSearch(newValue)}
            onInputChange={(_, newInputValue) => {
              if (highlightPlanSearch) setHighlightPlanSearch(false);
              setInputResultName(newInputValue);
            }}
            onFocus={() => {
              if (highlightPlanSearch) setHighlightPlanSearch(false);
            }}
            noOptionsText={ noResultsType === "custom result name & display coverage card" ?
                  <Typography
                    onClick={() => handleResultSearch("noResultsFound")}
                    style={{ cursor: "pointer" }}
                    className={`norstella-pf-noResultMessage norstella-pf-${safeChannelName}-noResultMessage norstella-pf-${searchPageState}-noResultMessage`}
                  >
                     <DynamicHtml part="pfPlanSearchNoResultMessage" input={noResultsMessage} />
                  </Typography>
                  :
                  <DynamicHtml part="pfPlanSearchNoResultMessage" input={noResultsMessage} className={`norstella-pf-noResultMessage norstella-pf-${safeChannelName}-noResultMessage norstella-pf-${searchPageState}-noResultMessage`} />
                }
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Search"
                className={`norstella-pf-plan-search-input norstella-pf-${safeChannelName}-plan-search-input norstella-pf-${searchPageState}-plan-search-input`}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <>
                      <Search className={`norstella-pf-plan-search-input-icon norstella-pf-${safeChannelName}-plan-search-input-icon norstella-pf-${searchPageState}-plan-search-input-icon`} />
                      {params.InputProps.startAdornment}
                    </>
                  ),
                  endAdornment: (
                    <>
                      {params.InputProps.endAdornment}
                      {selectedResult && (
                        <IconButton
                          className={`norstella-pf-autocomplete-custom-close norstella-pf-${safeChannelName}-autocomplete-custom-close norstella-pf-${searchPageState}-autocomplete-custom-close`}
                          tabIndex={0}
                          aria-label="Clear result selection"
                          onClick={handlePlanClear}
                        >
                          <ClearIcon />
                        </IconButton>
                      )}
                    </>
                  ),
                }}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default PlanSearchSection;
